import { useMemo, useState } from 'react';

import { ListResponsePagination } from '@shared/types/services';
import { defaultPagination } from '@shared/utils/http-client';

export const useLazyLoadItems = <TItem extends Item>() => {
  const [items, setItems] = useState<TItem[]>([]);
  const [pagination, setPagination] = useState<ListResponsePagination>(() => defaultPagination);

  return useMemo(() => {
    return {
      items: items,
      pagination: pagination,
      addItems: (newPagination: ListResponsePagination, newItems: TItem[]) => {
        setPagination(newPagination);

        if (newPagination.current_page === 1) {
          // Clear previous items if the new page is 1
          setItems(newItems);
        } else {
          // Otherwise, append new items to the existing ones
          setItems((prevItems) => [...prevItems, ...newItems]);
        }
      },
      updateItems: (updater: (prevItems: TItem[]) => TItem[]) => {
        setItems(updater);
      },
    };
  }, [items, pagination]);
};
